import React, { useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useTranslation } from 'react-i18next';
import { setHasImportantUnsavedChanges } from '@rd-web-markets/shared/dist/store/features/unsavedChangesSlice';

// the file is only kept locally and sent together with the notes on save
const doNotUpload = async () => {};

const AttachmentsForm = ({
  handleSubmit,
  loading,
  applicationSubmitted
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedFile, , setSelectedFile] = useFileUpload(doNotUpload, 'file', false);
  const [attachment, setAttachment] = useState({notes: ''});

  const addFile = file => {
    setSelectedFile(file);
    dispatch(setHasImportantUnsavedChanges(!!file));
  }

  const handleChange = e => {
    const value =
    e.target.type === 'checkbox'
      ? e.target.checked
      : e.target.value;

    dispatch(setHasImportantUnsavedChanges(true));

    setAttachment({
      ...attachment,
      [e.target.name]: value,
    });
  };

  const submit = () => {
    setSelectedFile(null);
    setAttachment({notes: ''});
    handleSubmit(attachment, selectedFile);
    dispatch(setHasImportantUnsavedChanges(false));
  };


  return (
    <>
      <Row className="pt-3">
        <Col md={2}>
          <p className="fw-bold">{t('attachment_section')}</p>
        </Col>
      </Row>
      <Row className="pt-3">
        <Col md={4}>
          <Form.Control
            onChange={handleChange}
            name="notes"
            placeholder={t('notes') + '...'}
            value={attachment.notes}
            size="md"
            type="text"
            disabled={applicationSubmitted}
          ></Form.Control>
        </Col>
        <Col md={3}>
          <FileUpload
            defaultDesignCustomStyle={{ width: 'auto' }}
            defaultBodyIcon='cloud_upload'
            title={t('upload_document')}
            file={selectedFile}
            onSelectFile={addFile}
            disabled={loading || applicationSubmitted}
          />
        </Col>
        <Col md={{span:1, offset: 1}}>
          <Button loading={loading} variant="primary" onClick={submit} disabled={applicationSubmitted}>
            <span className="material-icons md-18">save</span> {t('save')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default AttachmentsForm
